export enum USER_ROLE_ENUM {
  student = "student",
  teacher = "teacher",
  admin = "admin",
}
